// import React from 'react';
export const navImages = (items, profile) =>{
    let image_link = "";
    let highlighted_image = "";

    if(items.images.length > 0) {
        const image = items.images.find(item => item.profile === profile);
        highlighted_image = image.link.replace(/(\.[\w\d_-]+)$/i, '_highlight$1');
        image_link = image.link
    }
    return {
        image: image_link,
        highlighted_image: highlighted_image
    }
};
export default navImages;